/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { UserDto } from '../models/user-dto';
import { userGetAllUsers$Json } from '../fn/user/user-get-all-users-json';
import { UserGetAllUsers$Json$Params } from '../fn/user/user-get-all-users-json';
import { userGetAllUsers$Plain } from '../fn/user/user-get-all-users-plain';
import { UserGetAllUsers$Plain$Params } from '../fn/user/user-get-all-users-plain';
import { userGetUser$Json } from '../fn/user/user-get-user-json';
import { UserGetUser$Json$Params } from '../fn/user/user-get-user-json';
import { userGetUser$Plain } from '../fn/user/user-get-user-plain';
import { UserGetUser$Plain$Params } from '../fn/user/user-get-user-plain';
import { userResetPassword } from '../fn/user/user-reset-password';
import { UserResetPassword$Params } from '../fn/user/user-reset-password';
import { userSendSupportMail } from '../fn/user/user-send-support-mail';
import { UserSendSupportMail$Params } from '../fn/user/user-send-support-mail';
import { userSendTestMail } from '../fn/user/user-send-test-mail';
import { UserSendTestMail$Params } from '../fn/user/user-send-test-mail';
import { userSetPassword$Json } from '../fn/user/user-set-password-json';
import { UserSetPassword$Json$Params } from '../fn/user/user-set-password-json';
import { userSetPassword$Plain } from '../fn/user/user-set-password-plain';
import { UserSetPassword$Plain$Params } from '../fn/user/user-set-password-plain';
import { userUpdateUser } from '../fn/user/user-update-user';
import { UserUpdateUser$Params } from '../fn/user/user-update-user';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userGetUser()` */
  static readonly UserGetUserPath = '/api/User';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGetUser$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetUser$Plain$Response(params?: UserGetUser$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return userGetUser$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userGetUser$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetUser$Plain(params?: UserGetUser$Plain$Params, context?: HttpContext): Observable<UserDto> {
    return this.userGetUser$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGetUser$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetUser$Json$Response(params?: UserGetUser$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return userGetUser$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userGetUser$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetUser$Json(params?: UserGetUser$Json$Params, context?: HttpContext): Observable<UserDto> {
    return this.userGetUser$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `userGetAllUsers()` */
  static readonly UserGetAllUsersPath = '/api/User/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGetAllUsers$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetAllUsers$Plain$Response(params?: UserGetAllUsers$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDto>>> {
    return userGetAllUsers$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userGetAllUsers$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetAllUsers$Plain(params?: UserGetAllUsers$Plain$Params, context?: HttpContext): Observable<Array<UserDto>> {
    return this.userGetAllUsers$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserDto>>): Array<UserDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGetAllUsers$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetAllUsers$Json$Response(params?: UserGetAllUsers$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDto>>> {
    return userGetAllUsers$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userGetAllUsers$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetAllUsers$Json(params?: UserGetAllUsers$Json$Params, context?: HttpContext): Observable<Array<UserDto>> {
    return this.userGetAllUsers$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserDto>>): Array<UserDto> => r.body)
    );
  }

  /** Path part for operation `userUpdateUser()` */
  static readonly UserUpdateUserPath = '/api/User/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userUpdateUser()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userUpdateUser$Response(params?: UserUpdateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userUpdateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userUpdateUser$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userUpdateUser(params?: UserUpdateUser$Params, context?: HttpContext): Observable<void> {
    return this.userUpdateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userSetPassword()` */
  static readonly UserSetPasswordPath = '/api/User/set-password/{setId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSetPassword$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSetPassword$Plain$Response(params: UserSetPassword$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return userSetPassword$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSetPassword$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSetPassword$Plain(params: UserSetPassword$Plain$Params, context?: HttpContext): Observable<boolean> {
    return this.userSetPassword$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSetPassword$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSetPassword$Json$Response(params: UserSetPassword$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return userSetPassword$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSetPassword$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSetPassword$Json(params: UserSetPassword$Json$Params, context?: HttpContext): Observable<boolean> {
    return this.userSetPassword$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `userResetPassword()` */
  static readonly UserResetPasswordPath = '/api/User/reset-password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userResetPassword()` instead.
   *
   * This method doesn't expect any request body.
   */
  userResetPassword$Response(params?: UserResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userResetPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userResetPassword$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userResetPassword(params?: UserResetPassword$Params, context?: HttpContext): Observable<void> {
    return this.userResetPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userSendSupportMail()` */
  static readonly UserSendSupportMailPath = '/api/User/send-mail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSendSupportMail()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSendSupportMail$Response(params?: UserSendSupportMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userSendSupportMail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSendSupportMail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSendSupportMail(params?: UserSendSupportMail$Params, context?: HttpContext): Observable<void> {
    return this.userSendSupportMail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userSendTestMail()` */
  static readonly UserSendTestMailPath = '/api/User/test-mail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSendTestMail()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSendTestMail$Response(params?: UserSendTestMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userSendTestMail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSendTestMail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSendTestMail(params?: UserSendTestMail$Params, context?: HttpContext): Observable<void> {
    return this.userSendTestMail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
